module.exports = __webpack_public_path__ + "42075574777164cb0815eef1a02ed918.png";